import { render, staticRenderFns } from "./RcvPD_Items.vue?vue&type=template&id=0e284c76"
import script from "./RcvPD_Items.vue?vue&type=script&lang=js"
export * from "./RcvPD_Items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports